// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import { GeneralKind } from "../../../../define/GeneralKind";
import NormalGameManager from "../../../manager/NormalGameManager";
import LotteryBaseLayer from "../common/LotteryBaseLayer";
import { GoldFlowerDataManage } from "./data/GoldFlowerDataManage";
import { GoldFlowerKind } from "./data/GoldFlowerKind";
import GoldFlowerItemBase from "./GoldFlowerItemBase";
import GoldFlowerItemCom from "./GoldFlowerItemCom";

const {ccclass, property} = cc._decorator;

@ccclass
export default class GoldFlowerLayer extends LotteryBaseLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeCombinationLayout: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeReferLayout: cc.Node = null;

    @property(cc.Prefab)
    nodeItemComPrefab : cc.Prefab = null;

    @property({type:cc.Node,tooltip:"彩蛋页面"})
    patindPage:cc.Node = null;

    @property({type:sp.Skeleton,tooltip:"花的动画"})
    flowerAni:sp.Skeleton = null;

    /** 牌型数据 */
    private cardData: GoldFlowerKind.CardTypeData = null;
    private cardType: number = 0;

    /** 参照区是否已显示 */
    private bReferAreaShow = false;

    /** 是否是必中 */
    isBInfallible:boolean = false;
    
    flowerClickCount:number = 0;

    canTriggerPatind:boolean = true;

    // onLoad () {}

    start () {
        super.start();
        this.resetData();
    }

    // update (dt) {}

    resetData(isPainted:boolean = false) {
        this.bReferAreaShow = false;
        super.resetData();

        this.getCardTypeData(isPainted);
        this.resetReferArea();
    }

    /**
     * 获得牌型数据
     * @returns 
     */
    getCardTypeData(isPainted:boolean = false) {
        const normalCount = 4;
        // 是否必中
        let bInfallible = isPainted;

        let winArr: boolean[] = [];
        let numArr: number[] = [];
        let winCount = 0;
        let len = GoldFlowerKind.WinProb.length-1;
        for (let i = 0; i < normalCount; i++) {
            let idx = data_control.randomNumInt(1, len);
            let winPropInfo = GoldFlowerKind.WinProb[idx];
            let prob = winPropInfo.prob;
            if (bInfallible) {
                prob = 1;
            }
            
            let bWin = false;
            // 中奖
            if (data_control.isHitProbability(prob)) {
                bWin = true;
                winCount++;
            } 

            winArr.push(bWin);
            numArr.push(winPropInfo.sum);
        }

        let CardType = GoldFlowerKind.CardType;
        let cardType = data_control.randomNumInt(CardType.Min+1, CardType.Max-1);
        let cardData: number[] = [];

        // 排除牌
        let excludeArr: number[][] = [];
        if (winCount >= normalCount) {
            // 都中
            // if (data_control.isHitProbability(0.5)) {
            //     cardData = [14, 14, 14];
            //     cardType = CardType.SAN_TIAO;
            // } 
            if (cardType == CardType.SAN_TIAO) {
                excludeArr.push([14,14,14]);
            }
        } else if (winCount <= 0) {
            if (cardType == CardType.YI_ZHANG) {
                excludeArr.push([2,3,5]);
            }
        }
        if (cardData.length <= 0) {
            this.cardData = GoldFlowerDataManage.generateCardTypeRefer(cardType, excludeArr);
        } else {
            this.cardData = new GoldFlowerKind.CardTypeData();
            this.cardData.card = cardData;
        }
        this.cardData.card.sort((a,b)=> b-a);
        this.cardType = cardType;

        // 特殊控制
        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.goldFlowerLotteryNum >= GoldFlowerKind.GeneralValue.OPEN_GET_NVWA_STORE_5) {
            if (!winArr.includes(true)) {
                let widx = data_control.randomNumInt(0, winArr.length-1);
                winArr[widx] = true;
            }
        }
        if(isPainted){
            for(let i =0;i<numArr.length;i++){
                numArr[i] = 100000000;
            }
        }
        this.resetCombinationArea(winArr, numArr);
    }

    /**
     * 参照区
     */
    resetReferArea(){
        this.nodeReferLayout.removeAllChildren();
        this.generateBaseCard(this.cardData.card, this.cardType, this.nodeReferLayout);
    }

    /**
     * 组合区
     */
    resetCombinationArea(winArr: boolean[], numArr: number[]) {
        this.nodeCombinationLayout.removeAllChildren();

        let CardType = GoldFlowerKind.CardType;
        let cardType = this.cardType;
        let cardData = this.cardData.card;
        let bMin = GoldFlowerDataManage.isCardTypeMaxMinValue(cardType, cardData, false);
        let bMax = GoldFlowerDataManage.isCardTypeMaxMinValue(cardType, cardData, true);

        let bShowNvWaStone = false;
        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.goldFlowerLotteryNum >= GoldFlowerKind.GeneralValue.OPEN_GET_NVWA_STORE_5) {
            bShowNvWaStone = true;
        }
        
        for (let i = 0; i < winArr.length; i++) {
            let bWin = winArr[i];
            let num = numArr[i];

            let cardTypeT = 0;
            let bNvWaStone = false;
            let cardTypeRange = [CardType.Min+1, CardType.Max-1];
            if (bWin) {
                cardTypeRange[0] = cardType + (bMax ? 1 : 0);
                if (bShowNvWaStone) {
                    bShowNvWaStone = false;
                    bNvWaStone = true;
                }
            } else {
                cardTypeRange[1] = cardType + (bMin ? -1 : 0);
            }

            if (cardTypeRange[0] > cardTypeRange[1]) {
                console.error('出错了');
            }
            cardTypeT = data_control.randomNumInt(cardTypeRange[0], cardTypeRange[1]);
            let retData = GoldFlowerDataManage.generateCardTypeCom(
                cardTypeT
                , cardData
                , cardType
                , bWin
            );

            let nodeItem = cc.instantiate(this.nodeItemComPrefab);
            this.nodeCombinationLayout.addChild(nodeItem);

            let script = nodeItem.getComponent(GoldFlowerItemCom);
            script.setData(num, bWin, retData.card, cardTypeT, bNvWaStone);
        }
    }

    /**
     * 生成牌
     * @param card 
     * @param parent 
     */
    generateBaseCard(card: number[], cardType: number, parent: cc.Node) {
        let nodeItem = cc.instantiate(this.nodeItemPrefab);
        parent.addChild(nodeItem);

        let script = nodeItem.getComponent(GoldFlowerItemBase);
        script.setData(card, cardType);
    }

    checkJudge(pos1: cc.Vec2, pos2: cc.Vec2) {
        this.canTriggerPatind = false;
        this.checkJudgeLottery(pos1, pos2);
    }

    checkJudgeNode(pos: cc.Vec2) {
        this.canTriggerPatind = false;
        this.checkJudgeLottery(pos);
    }

    checkJudgeLottery(pos1: cc.Vec2, pos2: cc.Vec2 = null) {
        if (this.bFinishShow) {
            return;
        }
        if (!this.bReferAreaShow) {
            let referArr = [this.nodeReferLayout];
            let lenRefer = 0;
            for (let o of referArr) {
                let childrenRefer = o.children;
                lenRefer += childrenRefer.length;
                for (let i = 0; i < childrenRefer.length; i++) {
                    let childNode = childrenRefer[i];
                    let script = childNode.getComponent(GoldFlowerItemBase);
                    if (pos2) {
                        if (script.checkJudge(pos1, pos2)) {
                            lenRefer--;
                        }
                    } else {
                        if (script.checkJudgeNode(pos1)) {
                            lenRefer--;
                        }
                    }
                }
            }
            if (lenRefer <= 0) {
                this.bReferAreaShow = true;
            }
        }

        let childrenCom = this.nodeCombinationLayout.children;
        let lenCom = childrenCom.length;
        for (let i = 0; i < childrenCom.length; i++) {
            let childNode = childrenCom[i];
            let script = childNode.getComponent(GoldFlowerItemCom);
            if (script.isYetOpen()) {
                lenCom--;
            } else {
                if (pos2) {
                    if (script.checkJudge(pos1, pos2)) {
                        script.setYetOpen();
                        lenCom--;
                    }
                } else {
                    if (script.checkJudgeNode(pos1)) {
                        script.setYetOpen();
                        lenCom--;
                    }
                }
            }
            if (script.isYetOpen() && this.bReferAreaShow) {
                script.showAward();
            }
        }

        if (lenCom <= 0 && this.bReferAreaShow) {
            this.bFinishShow = true;
            this.showAllMask();
        }   
    }

    resetStartLottery() {
        let gameData = NormalGameManager._instance.getGameData();
        gameData.goldFlowerLotteryNum++;
        if (gameData.goldFlowerLotteryNum > GoldFlowerKind.GeneralValue.OPEN_GET_NVWA_STORE_5) {
            gameData.goldFlowerLotteryNum = 1;
        }
        NormalGameManager._instance.writeGameData();
    }


    onClickFlower(){
        this.flowerClickCount ++;
        if(this.flowerClickCount >= 5 && !NormalGameManager._instance.getGameData().goldFlowerTriggerPatind && this.canTriggerPatind){
            this.canTriggerPatind = false;
            NormalGameManager._instance.setGameData({goldFlowerTriggerPatind:true});
            O1HD.getManagers().soundMgr.playSound("flowerSound");
            this.patindPage.active = true;
            this.flowerAni.setAnimation(0,"animation",false);
            this.flowerAni.setCompleteListener(()=>{
                this.patindPage.active = false;
                this.flowerAni.setCompleteListener(()=>{});
                this.resetData(true)
            });
        }
    }
}
